import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../Hooks/useToggle';
import heroThumb from '../../assets/images/screenshots/backoffice.jpg';
import BackToTop from '../BackToTop';
import FooterHomeThree from '../Footer/FooterHomeThree';
import HeaderHomeFour from '../Header/HeaderHomeFour';
import Drawer from '../Mobile/Drawer';
import FeaturesHomeOne from './FeaturesHomeOne';
import HeroHomeFour from './HeroHomeFour';
import PricingHomeTwo from './PricingHomeTwo';
import ServicesHomeOne from './ServicesHomeOne';
import ServicesHomeTwo from './ServicesHomeTwo';
import SponserHomeTwo from './SponserHomeTwo';

// Tells search engines and AI assistants who makes OTO, where, and which profiles are ours.
const ORGANIZATION_SCHEMA = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Kapp MicroSystems',
    alternateName: 'Kapp',
    url: 'https://otocloud.io/',
    logo: 'https://kapp.rw/wp-content/uploads/sites/17/2024/05/kapp-logo-web.png',
    foundingDate: '2015',
    brand: { '@type': 'Brand', name: 'OTO by Kapp' },
    address: {
        '@type': 'PostalAddress',
        streetAddress: 'KK 565 St, 1st Floor 1F29, Gikondo',
        addressLocality: 'Kigali',
        addressCountry: 'RW',
    },
    sameAs: [
        'https://kapp.rw/',
        'https://x.com/kapp_rw',
        'https://www.youtube.com/channel/UCamoQNebvySL0FkGm1Y73VA',
    ],
};

function HomeFour() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <title>Business Apps for Hotels, Restaurants & Shops | OTO by Kapp</title>
                <meta
                    name="description"
                    content="Point of sale, hotel front desk, stock, invoicing and accounting in one system, made in Rwanda and used by businesses since 2015. Ask for a demo."
                />
                <meta property="og:image" content={heroThumb} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://otocloud.io/" />
                <meta
                    property="og:title"
                    content="OTO by Kapp: business apps for hotels, restaurants and shops"
                />
                <meta
                    property="og:description"
                    content="Point of sale, hotel front desk, stock, invoicing and accounting in one system, made in Rwanda since 2015."
                />
                <script type="application/ld+json">{JSON.stringify(ORGANIZATION_SCHEMA)}</script>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderHomeFour action={drawerAction.toggle} />
            <HeroHomeFour />
            <ServicesHomeOne className="pt-190" />
            <ServicesHomeTwo className="pt-100" />
            <FeaturesHomeOne className="bg-light" />
            <PricingHomeTwo />
            <SponserHomeTwo className="pt-90" />
            <FooterHomeThree className="home-four-footer" />
            <BackToTop className="back-to-top-3" />
        </>
    );
}

export default HomeFour;
